module.exports = "https://coursera_assets.s3.amazonaws.com/images/4117861503707653b276e5b8c7aede96.png";